import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { removeAlert } from 'store/actions/alertsActions';

// const variantEnum = {
//     default: 'default',
//     error: 'error',
//     success: 'success',
//     warning: 'warning',
//     info: 'info'
// }

let displayed = [];

export default function Alerts() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const dispatch = useDispatch();

    const alerts = useSelector((store) => {
        return store.alertsState.alerts
    });

    const storeDisplayed = (id) => {
        displayed = [...displayed, id];
    };

    const removeDisplayed = (id) => {
        displayed = [...displayed.filter(key => id !== key)];
    };

    useEffect(() => {
        alerts.forEach(({ key, mensagem, tipo, fechar = false }) => {
            if (fechar) {
                closeSnackbar(key);
            }

            if (displayed.includes(key)) return;

            enqueueSnackbar(mensagem, {
                key,
                variant: tipo,
                style: { whiteSpace: 'pre-line' },
                autoHideDuration: 10000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'center', },
                action: key => (
                    <IconButton color="inherit" size="small" onClick={() => closeSnackbar(key)}>
                        <CloseIcon />
                    </IconButton>
                ),
                onExited: (event, myKey) => {
                    dispatch(removeAlert(myKey));
                    removeDisplayed(myKey);
                },
            });

            storeDisplayed(key);

        })
    }, [alerts, closeSnackbar, enqueueSnackbar, dispatch]);

    return (
        <>

        </>
    );
}
